import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-de5eb696"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "statistics-panel"
};
const _hoisted_2 = {
  class: "stat-item"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "复送订单数", -1));
const _hoisted_4 = {
  class: "value"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "unit"
}, "笔", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
const _hoisted_7 = {
  class: "stat-item"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "复送总金额(CNY)", -1));
const _hoisted_9 = {
  class: "value"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "unit"
}, "元", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
const _hoisted_12 = {
  class: "stat-item"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "复送总金额(USD)", -1));
const _hoisted_14 = {
  class: "value"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "unit"
}, "美元", -1));
import { queryOrderStatistics } from '@/api/orderApi';
import { awaitWrap, OK } from '@/common';
import { message } from 'ant-design-vue';
const __default__ = {
  name: 'DuplicateStatic'
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, {
    expose
  }) {
    const orderNum = ref(0);
    const totalAmount = ref(0);
    const totalAmountUsd = ref(0);
    const duplicateRate = ref(0);
    const loading = ref(false);
    const getOrderStatistics = async obj => {
      loading.value = true;
      try {
        const [err, res] = await awaitWrap(queryOrderStatistics({
          ...obj,
          reshipStatusList: ['10', '20'],
          pageArrow: '1',
          pageSize: 10
        }));
        if (err) {
          return message.error(err.message);
        }
        if (res && res.code === OK) {
          var _res$data, _res$data2, _res$data3, _res$data4;
          orderNum.value = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.reshipSum;
          totalAmount.value = (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.reshipCnyAmount;
          totalAmountUsd.value = (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.reshipUsdAmount;
          duplicateRate.value = (_res$data4 = res.data) !== null && _res$data4 !== void 0 && _res$data4.reshipSumRate ? Number((res.data.reshipSumRate * 100).toFixed(2)) : 0;
        }
      } catch (error) {} finally {
        loading.value = false;
      }
    };
    expose({
      getOrderStatistics
    });
    return (_ctx, _cache) => {
      const _component_a_statistic = _resolveComponent("a-statistic");
      const _component_a_spin = _resolveComponent("a-spin");
      return _openBlock(), _createBlock(_component_a_spin, {
        spinning: loading.value
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_a_statistic, {
          value: orderNum.value
        }, {
          suffix: _withCtx(() => [_hoisted_5]),
          _: 1
        }, 8, ["value"])])]), _hoisted_6, _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_createVNode(_component_a_statistic, {
          value: totalAmount.value
        }, {
          suffix: _withCtx(() => [_hoisted_10]),
          _: 1
        }, 8, ["value"])])]), _hoisted_11, _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, [_createVNode(_component_a_statistic, {
          value: totalAmountUsd.value
        }, {
          suffix: _withCtx(() => [_hoisted_15]),
          _: 1
        }, 8, ["value"])])])])]),
        _: 1
      }, 8, ["spinning"]);
    };
  }
});